import React from 'react';
import axios from "axios";
import configData from "../../config/config.json";
import { connect } from "react-redux";
import { Form, Container, Row, Button, Col, Modal } from 'react-bootstrap'
import PrimaryButton from "../common/form/PrimaryButton.js";
import SecondaryButton from "../common/form/SecondaryButton.js";
import TextField from "../common/form/TextField.js";
import SelectField from "../common/form/SelectField.js";

import Alert from '../common/modal/Alert.js';
import AlertEntryEmailRow from '../controlPanel/AlertEntryEmailRow.js'
import { setSelectedControlPanelType, AlertListControlPanelKey } from "../../redux/actions/controlPanelActions.js";
import { saveUserViewAlert } from "../../redux/actions/alertActions.js";
import Loading from '../common/modal/Loading.js';
import { trimAlertFields, validateAlert } from "../common/function/alertValidation.js";
import { formatPhone } from "../common/function/formattingUtils.js";
import EmailAddressSelectionList from '../common/selection/EmailAddressSelectionList.js';
import PhoneNumberSelectionList from '../common/selection/PhoneNumberSelectionList.js';
import { checkIconGreen, spinnerIconGray } from "../../img/font_awesome/font_awesome.js"
import AlertEntryPhoneRow from '../controlPanel/AlertEntryPhoneRow.js';
import Confirmation from '../common/modal/Confirmation';
import translations from "../../config/translation/alert_entry_translations.json"

import { ALERT_TYPES, LOADING_STATUES } from "../constants/constants";

const componentName = AlertListControlPanelKey;

const mapStateToProps = (state) => {
	return {
		currentUser: state.currentUserReducer,
		language: state.languageReducer ? state.languageReducer : 'ENGLISH',
		alerttListFilters: state.alertListFiltersReducer,
		alertSettings: state.countyConfigAlertSettingsReducer,
		selectedAlert : state.userViewSelectedAlertReducer ,
		multiTenantSettings: state.countyConfigMultiTenantSettingsReducer
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName)),
		saveAlert: (alert, callback) => dispatch(saveUserViewAlert(alert, callback)),
		resetSelectedAlert: () => dispatch({ type: 'RESET_SELECTED_ALERT' })
	}
}

class UserViewEntry extends React.Component {
	state = {
		id: this.props.selectedAlert.id ? this.props.selectedAlert.id : 0,
		userId: this.props.currentUser.userId,
		username: this.props.selectedAlert.username ? this.props.selectedAlert.username : '',
		countyList: [{'NONE': ''}],
		countyCode: this.props.selectedAlert.countyCode ? this.props.selectedAlert.countyCode : null,
		alertType: this.props.selectedAlert.alertType ? this.props.selectedAlert.alertType : this.props.alertSettings.nameAlert === true ? 'NAME' : this.props.alertSettings.businessAlert === true ? 'BUSINESS' : 'PARCEL_ID',
		name: this.props.selectedAlert.name ? this.props.selectedAlert.name : '',
		firstName: this.props.selectedAlert.firstName ? this.props.selectedAlert.firstName : '',
		lastName: this.props.selectedAlert.lastName ? this.props.selectedAlert.lastName : '',
		businessName: this.props.selectedAlert.businessName ? this.props.selectedAlert.businessName : '',

		alertEmailAddresses: this.props.selectedAlert.alertEmailAddresses ? this.props.selectedAlert.alertEmailAddresses : [],
		alertPhones: this.props.selectedAlert.alertPhones ? this.props.selectedAlert.alertPhones : [],

		parcelId: this.props.selectedAlert.parcelId ? this.props.selectedAlert.parcelId : '',

		selectedEmailField: '',
		selectedPhoneField: '',
		statusType: 'A',
		showDeleteConfirmationDialog: false,
		loadingStatus: '',
		alertComponentType: ALERT_TYPES.OK,
		errors: {},
		showAlert: false,
		alertMessage: "",
		redirect: false,
		showUserList: false,
		showEmailAddressList: false,
		showPhoneNumberList: false
	}

	handleChange = (event) => {
		event.preventDefault();
		let targetValue = event.target.value;

		if (event.target.id && event.target.id.includes('emailEntry')) {
			const index = event.currentTarget.id.slice(-1);
			let alertEmailAddresses = this.state.alertEmailAddresses;
			alertEmailAddresses[index] = { id: index, value: targetValue, verified: alertEmailAddresses[index].verified, acknowledged: alertEmailAddresses[index].acknowledged, saved: false };
			this.setState({
				alertEmailAddresses,
				errors: {}
			});
		} else if (event.target.id && event.target.id.includes('phoneEntry')) {
			const index = event.currentTarget.id.slice(-1);
			let alertPhones = this.state.alertPhones;
			let value = formatPhone(targetValue, alertPhones[index].value);
			alertPhones[index] = { id: index, value, verified: alertPhones[index].verified, acknowledged: alertPhones[index].acknowledged, saved: false };
			this.setState({
				alertPhones,
				errors: {}
			});
		} else if (event.target.id && event.target.id.includes('emailAcknowledge')) {
			const index = event.currentTarget.id.slice(-1);
			let alertEmailAddresses = this.state.alertEmailAddresses;
			let acknowledged = alertEmailAddresses[index].acknowledged === true ? false : true;
			alertEmailAddresses[index] = { id: index, value: alertEmailAddresses[index].value, verified: alertEmailAddresses[index].verified, acknowledged, saved: false };
			this.setState({
				alertEmailAddresses,
				errors: {}
			});
		} else if (event.target.id && event.target.id.includes('phoneAcknowledge')) {
			const index = event.currentTarget.id.slice(-1);
			let alertPhones = this.state.alertPhones;
			let acknowledged = alertPhones[index].acknowledged === true ? false : true;
			alertPhones[index] = { id: index, value: alertPhones[index].value, verified: alertPhones[index].verified, acknowledged, saved: false };
			this.setState({
				alertPhones,
				errors: {}
			});
		} else {
			this.setState({
				[event.target.id]: targetValue ? targetValue : (event.target.type === 'number' ? 0 : targetValue),
				errors: {}
			})
		}
	}

	resendEmailVerification = (event) => {
		event.preventDefault();
		const index = event.target.id.slice(-1);
		let id = this.state.alertEmailAddresses[index].id;
		if (this.showLoading() === true) {
			let request = {
				id
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alertResendEmail", request, { withCredentials: true })
				.then((response) => {
					this.setState({ loadingStatus: "" }, this.showAlert(response.data.message));
				}, (error) => {
				});
		}
	}

	resendPhoneVerification = (event) => {
		event.preventDefault();
		const index = event.target.id.slice(-1);
		let id = this.state.alertPhones[index].id;
		if (this.showLoading() === true) {
			let request = {
				id
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alertResendPhone", request, { withCredentials: true })
				.then((response) => {
					this.setState({ loadingStatus: "" }, this.showAlert(response.data.message));
				}, (error) => {
				});
		}
	}

	showLoading = () => {
		if (this.state.loadingStatus === "") {
			this.setState({
				loadingStatus: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	hideLoading = (loadingStatus) => {
		if (loadingStatus === 'ERROR') {
			this.setState({
				loadingStatus: "",
				alertComponentType: ALERT_TYPES.WARNING
			})
		} else {
			this.setState({
				loadingStatus: "",
				alertComponentType: ALERT_TYPES.OK
			})
		}
	}

	handleCloseClick = (event) => {
		if (event) {
			event.preventDefault();
		 }
		 this.setState({  errors: {} })
		 this.props.handleClose();
	}

	handleSubmit = (event) => {
		event.preventDefault();
		const trimmedAlertFields = trimAlertFields(this.state);
		this.setState({ ...trimmedAlertFields },
			function () {
				this.validateAndSubmit();
			}
		)
	}

	handleSaveResult = (redirect, errorFound, message) => {
		let alertComponentType = errorFound ? 'WARNING' : '';
		this.setState({ loadingStatus: "", redirect, alertComponentType }, this.showAlert(message))
	}

	validateAndSubmit = () => {

		let errors = validateAlert(this.state, this.state.id === 0, this.props.multiTenantSettings.multiTenant === true);

		if (errors && Object.keys(errors).length > 0) {
			this.setState({ errors });
			return;
		}

		if (this.showLoading() === true) {
			let { alertComponentType, username, selectedEmailField, selectedPhoneField, showDeleteConfirmationDialog, loadingStatus, errors, showAlert, alertMessage, redirect, showUserList, showEmailAddressList, showPhoneNumberList, ...request } = this.state; // remove UI only fields before submitting
			this.props.saveAlert(request, this.handleSaveResult);
		}
	}

	// Delete methods
	handleDeleteAlert = () => {
		if (this.showLoading() === true) {
			let request = {
				alertId: this.state.id,
			};

			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alertDelete", request, { withCredentials: true })
				.then((response) => {
					this.setState({ loadingStatus: "", redirect: true }, this.showAlert(response.data.message));
				}, (error) => {

					this.setState({ loadingStatus: "", redirect: false }, this.showAlert(error.message));
				});
		}
	}

	showDeleteConfirmation = (event) => {
		event.preventDefault();
		this.setState({
			showDeleteConfirmationDialog: true
		})
	}

	hideDeleteConfirmation = () => {
		this.setState({
			showDeleteConfirmationDialog: false
		})
	}

	// Delete methods - End

	handleAddPhone = (event) => {
		if (event) {
			event.preventDefault();
		}
		let alertPhones = this.state.alertPhones;
		if (alertPhones.length >= this.props.alertSettings.numberOfPhones) {
			return;
		}
		alertPhones.push({ id: 0, value: '', verified: false, acknowledged: false, saved: false })
		this.setState({
			alertPhones
		})
	}

	handleDeletePhone = (event) => {
		event.preventDefault();

		const index = event.currentTarget.id.slice(-1);
		let alertPhones = this.state.alertPhones;
		alertPhones.splice(index, 1);

		this.setState({
			alertPhones
		});
	}

	handleAddEmail = (event) => {
		if (event) {
			event.preventDefault();
		}
		let alertEmailAddresses = this.state.alertEmailAddresses;
		if (alertEmailAddresses.length >= this.props.alertSettings.numberOfEmails) {
			return;
		}
		alertEmailAddresses.push({ id: 0, value: '', verified: false, acknowledged: false, saved: false })
		this.setState({
			alertEmailAddresses
		})
	}

	handleDeleteEmail = (event) => {
		event.preventDefault();

		const fieldNumber = event.currentTarget.id.slice(-1);
		let alertEmailAddresses = this.state.alertEmailAddresses;
		alertEmailAddresses.splice(fieldNumber, 1);

		this.setState({
			alertEmailAddresses
		});
	}

	handleEmailLookup = (event) => {
		event.preventDefault();

		const fieldNumber = event.currentTarget.id.slice(-1);
		this.setState({
			selectedEmailField: fieldNumber,
			showEmailAddressList: true
		});
	}

	handleCloseEmailLookup = (selectedId, selectedName) => {
		let index = this.state.selectedEmailField;
		index = parseInt(index);
		let alertEmailAddresses = this.state.alertEmailAddresses;
		alertEmailAddresses[index].id = selectedId;
		alertEmailAddresses[index].value = selectedName;
		this.setState({
			alertEmailAddresses,
			showEmailAddressList: false,
		})
	}

	handlePhoneLookup = (event) => {
		event.preventDefault();

		const fieldNumber = event.currentTarget.id.slice(-1);
		this.setState({
			selectedPhoneField: fieldNumber,
			showPhoneNumberList: true
		});
	}

	handleClosePhoneLookup = (selectedId, selectedName) => {
		let index = this.state.selectedPhoneField;
		index = parseInt(index);
		let alertPhones = this.state.alertPhones;
		alertPhones[index].id = selectedId;
		alertPhones[index].value = selectedName;
		this.setState({
			alertPhones,
			showPhoneNumberList: false,
		})
	}

	showAlert = (alertMessage) => {
		this.setState({
			showAlert: true,
			alertMessage
		})
	}

	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: '',
			alertComponentType: ''
		})

		if (this.state.redirect === true) {
			this.props.resetSelectedAlert();
			window.location.reload(); // Kludge to force refresh the browser to hide the entry modal.
		}
	}

	componentDidMount() {
		axios.get(configData.LANDNOTIFICATION_SERVER_URL + "helperdata/multiTenantList", { withCredentials: true })
			.then(
				(response) => {
					const content = response.data.content;
					let codeDescriptionResultList = content.codeDescriptionResultList;
					this.setState({
						countyList: codeDescriptionResultList
					});
				},
				(error) => {
					alert("error");
					//   handleError(error, this.props.history);
				}
			);

		// new alert
		if (!this.props.selectedAlert.id || this.props.selectedAlert.id === 0) {
			this.handleAddEmail();
			this.handleAddPhone();
			return;
		}
	}

	render() {
		let disabledFlag = this.state.id !== 0;

		let county =<></>;
		if (this.props.multiTenantSettings.multiTenant === true) {
		 	county = <SelectField formGroup={{ id: 'countyCode', label: translations[this.props.language].county, fieldType: 'select', labelFor: 'countyCode', primaryCriteria: true, value: this.state.countyCode, required: true, options: this.state.countyList }} disabled={this.props.disabled} onChange={this.handleChange} />
		}
		
		let alertTypeOptions = [];
		if (this.props.alertSettings.businessAlert === true) {
			alertTypeOptions.push({ code: "BUSINESS", description: translations[this.props.language].business_trust });
		}
		if (this.props.alertSettings.nameAlert === true) {
			alertTypeOptions.push({ code: "NAME", description: translations[this.props.language].person });
		}
		if (this.props.alertSettings.parcelIdAlert === true) {
			alertTypeOptions.push({ code: "PARCEL_ID", description: translations[this.props.language].parcel_id });
		}

		let alertType = <SelectField formGroup={{ id: 'alertType', label: translations[this.props.language].monitor, fieldType: 'select', labelFor: 'alertType', primaryCriteria: true, value: this.state.alertType, required: true, options: alertTypeOptions }} disabled={this.props.disabled} onChange={this.handleChange} />

		if (disabledFlag) {
			let alertTypeDescription = translations[this.props.language].parcel_id;
			if (this.state.alertType === 'BUSINESS') {
				alertTypeDescription = translations[this.props.language].business_trust;
			} else if (this.state.alertType === 'NAME') {
				alertTypeDescription = translations[this.props.language].person;
			}
			alertType = <TextField formGroup={{ id: 'alertType', label: translations[this.props.language].monitor, fieldType: 'text', labelFor: 'alertType', value: alertTypeDescription, primaryCriteria: true, disableField: true }} onChange={this.handleChange} />
		}

		let recipientsLabelStyle = { fontSize: '0.75em', marginLeft: 3 }
		if (this.state.errors['recipientsLabel'] === true) {
			recipientsLabelStyle = { fontSize: '1em', marginLeft: 3, color: "red", fontWeight: "bold" }
		}

		let emailAcknowledgement = this.props.alertSettings.emailAcknowledgement;
		if (this.props.language === 'SPANISH') {
			emailAcknowledgement = this.tra
		}

		return (
			<>
				<Modal show={this.props.show} onHide={this.handleCloseClick} size="lg" centered>
					<Modal.Header style={{ background: '#145A7B', color: 'white' }}>
						<Modal.Title>{translations[this.props.language].alert_setup}</Modal.Title>
						<span style={{ textAlign: 'right' }}><Button variant="link" id={'emailDelete' + this.props.index} style={{textDecoration: 'none'}} onClick={this.handleCloseClick} aria-label='Close'>&#x2716;</Button></span>
					</Modal.Header>
					<Modal.Body>
						<Container style={{ paddingLeft: 10, paddingBottom: 20, marginTop: 10 }}>
							<Row>
								<Col>
									<Form onSubmit={this.handleSubmit}>
										<Form.Row>
											<Form.Group controlId='name'>
												<TextField formGroup={{ label: translations[this.props.language].alert_nickname, fieldType: 'text', labelFor: 'name', value: this.state.name, required: true, primaryCriteria: true, hideRow: disabledFlag }} onChange={this.handleChange} />
												<div style={{ fontSize: '0.75em', marginLeft: 3 }} >{translations[this.props.language].nickname_hint}</div>
												<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['name']}</div>
											</Form.Group>
										</Form.Row>

										<h5 style={{ textDecoration: 'underline' }}>{translations[this.props.language].alert_criteria}</h5>
										{
											this.props.multiTenantSettings.multiTenant === true && 
											<Form.Row style={{ marginLeft: -1 }}>
												<Form.Group>
													{county}
													<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['countyCode']}</div>
												</Form.Group>
											</Form.Row>
										}
										<Form.Row style={{ marginLeft: -1 }}>
											<Form.Group>{alertType}</Form.Group>
										</Form.Row>
										<Form.Row>
											{
												(this.state.alertType !== 'BUSINESS') !== true && 
												<Form.Group controlId='businessName'>
													<TextField formGroup={{ label: translations[this.props.language].business_trust_name, fieldType: 'text', labelFor: 'businessName', value: this.state.businessName, required: true, primaryCriteria: true }} onChange={this.handleChange} />
													<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['businessName']}</div>
												</Form.Group>
											}
											{
												(this.state.alertType !== 'NAME') !== true && 
												<Form.Group controlId='firstName'>
													<TextField formGroup={{ label: translations[this.props.language].first_name, fieldType: 'text', labelFor: 'firstName', value: this.state.firstName, required: true, primaryCriteria: false }} onChange={this.handleChange} />
													<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['firstName']}</div>
												</Form.Group>
											}
											{
												(this.state.alertType !== 'NAME') !== true && 
												<Form.Group controlId='lastName'>
													<TextField formGroup={{ label: translations[this.props.language].last_name, fieldType: 'text', labelFor: 'lastName', value: this.state.lastName, required: true, primaryCriteria: true }} onChange={this.handleChange} />
													<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['lastName']}</div>
												</Form.Group>
											}
											{
												(this.state.alertType !== 'PARCEL_ID') !== true && this.props.alertSettings.parcelIdAlert === true &&
												<Form.Group controlId='parcelId'>
													<TextField formGroup={{ label: translations[this.props.language].parcel_id, fieldType: 'text', labelFor: 'parcelId', value: this.state.parcelId, required: true, primaryCriteria: true, hintLink: this.props.alertSettings.pidLink }} onChange={this.handleChange} />
													<div style={{ color: "red", fontWeight: "bold" }}>{this.state.errors['parcelId']}</div>
												</Form.Group>
											}
										</Form.Row>
										<h5 style={{ textDecoration: 'underline' }}>{translations[this.props.language].alert_recipients}</h5>
										<div style={recipientsLabelStyle} >{translations[this.props.language].minimum_recipients}</div>
										<h6>{translations[this.props.language].up_to} {this.props.alertSettings.numberOfEmails}  {translations[this.props.language].email_recipients}</h6>
										<Row>
											<Col lg={10} md={10} sm={12} xs={12}>
												{
													this.state.alertEmailAddresses.map((emailAddress, index) => {
														return (
															<AlertEntryEmailRow id={index} key={emailAddress.id && emailAddress.id > 0 ? emailAddress.id : index} index={index} emailAddress={emailAddress} acknowledgement={emailAcknowledgement} errors={this.state.errors} onDelete={this.handleDeleteEmail} onChange={this.handleChange} onClick={this.handleEmailLookup} onResend={this.resendEmailVerification} ></AlertEntryEmailRow>
														)
													})
												}
											</Col>
										</Row>
										<Form.Row>
											{
												this.state.alertEmailAddresses.length < this.props.alertSettings.numberOfEmails &&
												<Button variant="link" id='addEmail' className='shadow-none' onClick={this.handleAddEmail}><strong>{this.state.alertEmailAddresses.length === 0 ? translations[this.props.language].add_email : translations[this.props.language].add_another_email}</strong></Button>
											}
											{
												this.state.alertEmailAddresses.length >= this.props.alertSettings.numberOfEmails &&
												<>&nbsp;</>
											}
										</Form.Row>
									
										<h6>{translations[this.props.language].up_to} {this.props.alertSettings.numberOfPhones} {translations[this.props.language].text_recipients}</h6>
										<Row>
											<Col lg={10} md={10} sm={12} xs={12}>
												{
													this.state.alertPhones.map((phone, index) => {
														return (
															<AlertEntryPhoneRow id={index} key={phone.id && phone.id > 0 ? phone.id : index} index={index} phone={phone} acknowledgement={this.props.alertSettings.phoneAcknowledgement} errors={this.state.errors} onDelete={this.handleDeletePhone} onChange={this.handleChange} onClick={this.handlePhoneLookup} onResend={this.resendPhoneVerification} ></AlertEntryPhoneRow>
														)
													})
												}
											</Col>
										</Row>
										<Form.Row>
											{
												this.state.alertPhones.length < this.props.alertSettings.numberOfPhones &&
												<Button variant="link" id='addPhone' className='shadow-none' onClick={this.handleAddPhone}><strong>{this.state.alertPhones.length === 0 ? translations[this.props.language].add_phone : translations[this.props.language].add_another_phone}</strong></Button>
											}
											{
												this.state.alertPhones.length >= this.props.alertSettings.numberOfPhones &&
												<>&nbsp;</>
											}
										</Form.Row>
										<Row>&nbsp;</Row>
										<Row>
										<Col>
										<PrimaryButton buttonLabel={translations[this.props.language].done} disabled={this.state.status === LOADING_STATUES.LOADING} />&nbsp;&nbsp;
										<SecondaryButton buttonLabel={translations[this.props.language].cancel} disabled={this.state.status === LOADING_STATUES.LOADING} onClick={this.handleCloseClick} />&nbsp;&nbsp;&nbsp;&nbsp;
										{
											this.state.status === LOADING_STATUES.SUCCESS &&
											<>
												<span style={{ width: 18, verticalAlign: "bottom", paddingBottom: 1, display: "inline-block" }}>{checkIconGreen}</span>
												<span className="sr-only">Saved</span>
											</>
										}
										{
											this.state.status === LOADING_STATUES.LOADING &&
											<>
												<span style={{ width: 18, verticalAlign: "bottom", marginBottom: 1, display: "inline-block" }}>{spinnerIconGray}</span>
												<span className="sr-only">Saving in Progress</span>
											</>
										}
										</Col>
										{
											this.state.id != null && this.state.id != undefined && this.state.id !== 0 &&
											<Col>
												<Button variant="danger" onClick={this.showDeleteConfirmation} disabled={this.state.status === LOADING_STATUES.LOADING} >{translations[this.props.language].delete_alert}</Button>&nbsp;&nbsp;
											</Col>
										}
										</Row>
									</Form>
								</Col>
							</Row>

							<Alert type={this.state.alertComponentType} show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} />
							<Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
							<Confirmation show={this.state.showDeleteConfirmationDialog} cancelConfirmation={this.hideDeleteConfirmation} proceedConfirmation={this.handleDeleteAlert} question={translations[this.props.language].delete_alert_question} />
							<EmailAddressSelectionList userId={this.state.userId} showModal={this.state.showEmailAddressList} onHide={(selectedId, selectedName) => this.handleCloseEmailLookup(selectedId, selectedName)} />
							<PhoneNumberSelectionList userId={this.state.userId} showModal={this.state.showPhoneNumberList} onHide={(selectedId, selectedName) => this.handleClosePhoneLookup(selectedId, selectedName)} />
						</Container>
					</Modal.Body>
				</Modal>
			</>
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserViewEntry);
